import { useState, useRef, useEffect } from 'react';
import { Icon } from '@iconify/react';
import { portfolioData } from '../../data/portfolioData';
import { useTheme } from '../../context/ThemeContext';

const Terminal = () => {
  const [input, setInput] = useState('');
  const [history, setHistory] = useState([
    { type: 'system', content: `Mario Panenko Network OS [Version 1.0.25]` },
    { type: 'system', content: `Copyright (c) ${new Date().getFullYear()} Panenko. All rights reserved.` },
    { type: 'system', content: 'Type "help" to see available commands.' },
    { type: 'empty', content: '' },
  ]);
  const scrollRef = useRef(null);
  const inputRef = useRef(null);
  const { isDarkMode, toggleTheme } = useTheme();

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [history]);

  const handleCommand = (e) => {
    if (e.key === 'Enter') {
      const cmd = input.toLowerCase().trim();
      const newHistory = [...history, { type: 'input', content: `> ${input}` }];

      switch (cmd) {
        case 'help':
          newHistory.push({ type: 'system', content: 'Available commands: help, whoami, skills, experience, education, projects, driving, hobby, learning, contact, clear, theme' });
          break;
        case 'whoami':
          newHistory.push({ type: 'system', content: `User: ${portfolioData.hero.name}\nRole: ${portfolioData.hero.roles.join(' | ')}\nStatus: Ing. — Absolvent Technickej univerzity v Košiciach (TUKE), Máj 2026.` });
          break;
        case 'skills':
          portfolioData.skills.forEach(cat => {
            newHistory.push({ type: 'highlight', content: `--- ${cat.title} ---` });
            newHistory.push({ type: 'system', content: cat.skills.map(s => s.name).join(', ') });
          });
          break;
        case 'experience':
          newHistory.push({ type: 'highlight', content: '--- IBM Slovensko (Jun 2025 – Dec 2025) ---' });
          newHistory.push({ type: 'system', content: 'Salesforce Marketing Cloud Consultant (Contract)' });
          newHistory.push({ type: 'system', content: 'Six months on a Salesforce Marketing Cloud project for an enterprise client.' });
          newHistory.push({ type: 'system', content: 'Built customer journeys from scratch in SFMC — flow logic, send configuration,' });
          newHistory.push({ type: 'system', content: 'data extensions, automations. Distributed team, English-only communication,' });
          newHistory.push({ type: 'system', content: 'delivery tracked through Workfront and Confluence.' });
          newHistory.push({ type: 'empty', content: '' });
          newHistory.push({ type: 'highlight', content: '--- Freelance (Dec 2020 – present) ---' });
          newHistory.push({ type: 'system', content: 'Web Developer' });
          newHistory.push({ type: 'system', content: 'Web applications for paying clients. Mostly Next.js, sometimes with a headless' });
          newHistory.push({ type: 'system', content: 'CMS like Sanity when the client needs to publish content independently.' });
          newHistory.push({ type: 'system', content: 'Selected: byadamsoltes.com, oym.sk, panenko.dev.' });
          break;
        case 'education':
          newHistory.push({ type: 'highlight', content: '--- Technical University of Košice (Sep 2024 – May 2026) ---' });
          newHistory.push({ type: 'system', content: "Engineer's degree (Ing.), Computer Networks and Telecommunications ✓ Graduated" });
          newHistory.push({ type: 'system', content: "Grades: Thesis A (92%) | State Exam (Networks): B (84%)" });
          newHistory.push({ type: 'system', content: 'Engineering thesis: full-stack web application for word-targeted speech therapy.' });
          newHistory.push({ type: 'system', content: 'Stack: Next.js, Tailwind, Supabase, Vercel. Continuation of bachelor\'s research,' });
          newHistory.push({ type: 'system', content: 'rebuilt as a production-grade product.' });
          newHistory.push({ type: 'empty', content: '' });
          newHistory.push({ type: 'highlight', content: '--- Technical University of Košice (Sep 2021 – Jun 2024) ---' });
          newHistory.push({ type: 'system', content: "Bachelor's degree (Bc.), Computer Networks and Telecommunications" });
          newHistory.push({ type: 'system', content: "Grades: Thesis B (85%)" });
          newHistory.push({ type: 'system', content: "Bachelor's thesis: web application for speech therapy exercises." });
          newHistory.push({ type: 'empty', content: '' });
          newHistory.push({ type: 'highlight', content: '--- Technical Academy Spišská Nová Ves (Sep 2017 – Jun 2021) ---' });
          newHistory.push({ type: 'system', content: '2675 M ELECTRICAL ENGINEERING - orientation: intelligent technologies' });
          newHistory.push({ type: 'system', content: 'Certification: § 21 (Elektrotechnická spôsobilosť / Electrical safety certification)' });
          break;
        case 'projects':
          portfolioData.projects.forEach(p => {
            newHistory.push({ type: 'system', content: `• ${p.title} - ${p.url}` });
          });
          break;
        case 'driving':
          newHistory.push({ type: 'highlight', content: '--- Vodičské oprávnenia ---' });
          newHistory.push({ type: 'system', content: '• Skupiny: A, A1, A2, B, B1' });
          break;
        case 'learning':
          newHistory.push({ type: 'highlight', content: '--- Aktuálne sa učím ---' });
          newHistory.push({ type: 'system', content: 'Next.js, Integrácia AI nástrojov do workflow, Advanced Networking (CCNP level).' });
          break;
        case 'hobby':
          newHistory.push({ type: 'highlight', content: '--- Mimopracovné aktivity ---' });
          newHistory.push({ type: 'system', content: '• Jazda na motorke (BMW R 1200 GS) - dobrodružná turistika' });
          newHistory.push({ type: 'system', content: '• Automobily (Volkswagen Tiguan Mk2 2017) - technika a šoférovanie' });
          newHistory.push({ type: 'system', content: '• Zdravý životný štýl (Gym / Fitness) & neustály sebarozvoj' });
          break;
        case 'contact':
          newHistory.push({ type: 'system', content: `Email: ${portfolioData.social.email}\nLinkedIn: ${portfolioData.social.linkedin}` });
          break;
        case 'clear':
          setHistory([]);
          setInput('');
          return;
        case 'theme':
          toggleTheme();
          newHistory.push({ type: 'system', content: `Theme switched to ${isDarkMode ? 'light' : 'dark'} mode.` });
          break;
        case '':
          break;
        default:
          newHistory.push({ type: 'error', content: `Command not found: ${cmd}. Type "help" for assistance.` });
      }

      setHistory(newHistory);
      setInput('');
    }
  };

  const focusInput = () => {
    inputRef.current?.focus();
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div 
        onClick={focusInput}
        className="bg-[#FBFAF8] dark:bg-[#121212] rounded-xl overflow-hidden shadow-xl dark:shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-gray-200 dark:border-gray-800 font-mono text-sm group"
      >
        {/* Terminal Header */}
        <div className="bg-[#EAEAEA] dark:bg-[#1C1C1C] px-4 py-3 flex items-center justify-between border-b border-gray-300 dark:border-gray-800">
          <div className="flex gap-2">
            <div className="w-3 h-3 rounded-full bg-[#FF5F56] border border-[#E0443E]" />
            <div className="w-3 h-3 rounded-full bg-[#FFBD2E] border border-[#DEA123]" />
            <div className="w-3 h-3 rounded-full bg-[#27C93F] border border-[#1AAB29]" />
          </div>
          <div className="text-gray-500 dark:text-gray-500 text-xs flex items-center gap-2">
            <Icon icon="mdi:console" />
            panenko@network-os ~
          </div>
          <div className="w-12" /> {/* Spacer */}
        </div>

        {/* Terminal Body */}
        <div 
          ref={scrollRef}
          className="p-6 h-[400px] overflow-y-auto custom-scrollbar bg-[#FBFAF8] dark:bg-[#121212]"
        >
          {history.map((line, i) => (
            <div 
              key={i} 
              className={`mb-1 whitespace-pre-wrap leading-relaxed ${
                line.type === 'input' ? 'text-blue-600 dark:text-blue-400' : 
                line.type === 'highlight' ? 'text-green-600 dark:text-green-400 font-bold' :
                line.type === 'error' ? 'text-red-600 dark:text-red-400' :
                'text-gray-700 dark:text-gray-300'
              }`}
            >
              {line.content}
            </div>
          ))}
          <div className="flex items-center gap-2 mt-2">
            <span className="text-green-600 dark:text-green-500 font-bold">panenko@dev:~$</span>
            <input 
              ref={inputRef}
              type="text" 
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleCommand}
              className="bg-transparent border-none outline-none text-gray-900 dark:text-white flex-grow caret-blue-500"
              spellCheck="false"
            />
          </div>
        </div>
      </div>
      <p className="text-center mt-6 text-gray-500 text-xs animate-pulse">
        Click terminal to focus and type 'help'
      </p>
    </div>
  );
};

export default Terminal;
